export const isDomain = (domain: string) => {
  return domain.includes(".");
};
